/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCherishedSalvage32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M1.5 30.5h29'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M24.582 25.644l3.511-.264.247 3.277a1.223 1.223 0 01-1.127 1.311l-1.073.08a1.222 1.222 0 01-1.31-1.126l-.248-3.278z'
      />
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M24 14.42l-1.225-7.46a1.4 1.4 0 00-1.486-1.169l-6.613.5'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M15.59 18.145l1.096-.082a2.465 2.465 0 012.644 2.273l.492 6.516M15.328 14.655c4.123-.311 7-.302 8.905-.2a3.932 3.932 0 013.355 3.595c.272 3.211.608 7.668.608 7.668'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M28.196 25.719l-11.966.902'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M28.715 12.643l-.583.348a6.59 6.59 0 01-2.888.916l-1.44.109'
      />
      <path
        fill='currentColor'
        stroke='currentColor'
        strokeWidth={1.5}
        d='M6.89 30.782l-.056-.748-1.073.081a.473.473 0 01-.507-.435h0l-.128-1.696-.01-.12 2.017-.152m-.243 3.07l-.057-.748a.473.473 0 00.436-.506h0l-.128-1.697-.008-.119m-.243 3.07l-1.073.081m1.073-.08a1.223 1.223 0 001.127-1.312l-.137-1.815-.747.056'
      />
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M6.715 15.724l.092-7.56a1.4 1.4 0 011.295-1.378l6.613-.499'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M15.588 18.145l-1.096.083a2.466 2.466 0 00-2.274 2.644l.492 6.516M15.326 14.655c-4.122.311-6.965.752-8.835 1.138a3.932 3.932 0 00-2.777 4.058c.213 3.216.549 7.673.549 7.673'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M4.262 27.524l11.966-.903'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M1.79 14.673l.628.257c.948.388 1.972.55 2.993.473l1.44-.109'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M10.964 6.758l-.737 3.28a.19.19 0 00.22.228l3.284-.612a.236.236 0 01.24.366c-.56.825-1.657 2.447-1.657 2.447l.84.863M21.9 14.141s0 0 0 0a2.458 2.458 0 00-2.646-2.266l-.234.018a2.477 2.477 0 00-2.275 2.656s0 0 0 0'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M22.898 21.77l2.213-1.956M25.048 21.839l-2.083-2.095'
      />
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M7.419 19.764a1.501 1.501 0 01.225 2.992 1.5 1.5 0 01-.225-2.992z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M8.544 29.058A.608.608 0 018 28.453V27H4.5v1.578a.625.625 0 01-.393.579.437.437 0 00.162.843h4.228a.472.472 0 00.05-.942h-.003z'
      />
    </svg>
  );
}

export default SvgCherishedSalvage32;
